import React from 'react';
import './igsidebar_components/styles.scss';
import { IntlProvider } from 'react-intl';
import LocaleStore from './common_components/localization/LocaleStore';
import boardLocales from '../locales/board.json';
import bmcLocales from '../locales/bmc.json';
import roadmapLocales from '../locales/igroadmap.json';
import industriesLocales from '../locales/industries.json';
import sidebarLocales from '../locales/sidebar.json';
import Main from './igsidebar_components/Main';

export default class IgSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.localeStore = new LocaleStore(props.locale, [
      boardLocales,
      roadmapLocales,
      bmcLocales,
      industriesLocales,
      sidebarLocales,
    ]);
  }

  render() {
    return (
      <div className="main-sidebar">
        <IntlProvider
          locale={this.localeStore.locale}
          messages={this.localeStore.messages}
        >
          <Main {...this.props} />
        </IntlProvider>
      </div>
    );
  }
}
